/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Missing_Group_ErrorInputs */



/**
* | output |
* | --- |
* | "One or both Event Groups could not be found." |
*
* @param {Event_Group_Sync_Missing_Group_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_missing_group_error = /** @type {((inputs?: Event_Group_Sync_Missing_Group_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Missing_Group_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("One or both Event Groups could not be found.")
	if (locale === "de") return /** @type {LocalizedString} */ ("One or both Event Groups could not be found.")
	if (locale === "it") return /** @type {LocalizedString} */ ("One or both Event Groups could not be found.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("One or both Event Groups could not be found.")
	if (locale === "es") return /** @type {LocalizedString} */ ("One or both Event Groups could not be found.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("One or both Event Groups could not be found.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("One or both Event Groups could not be found.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("One or both Event Groups could not be found.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("One or both Event Groups could not be found.")
	return /** @type {LocalizedString} */ ("One or both Event Groups could not be found.")
});